import posthog from "posthog-js"

let initialized = false

export function init(apiKey, { apiHost, userId } = {}) {
  if (initialized) return
  initialized = true

  try {
    posthog.init(apiKey, {
      api_host: apiHost,
      ui_host: "https://eu.posthog.com",
      capture_pageview: "history_change",       // Track page views on initial load + history changes (Turbo navigation)
      capture_pageleave: "if_capture_pageview",  // Only track page leave if pageview was tracked
      person_profiles: "identified_only",        // Only create person profiles for identified users
      autocapture: true,
      opt_out_capturing_by_default: true,        // Start silent — analytics controller opts in based on market/consent
      disable_session_recording: true,           // Session recording requires explicit "all" consent
      persistence: "localStorage+cookie",        // Persist identity across sessions
      bootstrap: userId ? { distinctID: String(userId), isIdentifiedID: true } : undefined
    })
  } catch (error) {
    initialized = false
    console.error("[analytics] init failed:", error)
  }
}

export function identify(userId, properties = {}) {
  if (!initialized) return

  posthog.identify(String(userId), properties)
}

export function group(groupType, groupKey, properties = {}) {
  if (!initialized) return

  posthog.group(groupType, String(groupKey), properties)
}

export function capture(event, properties = {}) {
  if (!initialized) return

  posthog.capture(event, properties)
}

export function optIn() {
  if (!initialized) return

  posthog.opt_in_capturing()
}

export function optOut() {
  if (!initialized) return

  posthog.opt_out_capturing()
}

export function startSessionRecording() {
  if (!initialized) return

  posthog.startSessionRecording()
}

export function stopSessionRecording() {
  if (!initialized) return

  posthog.stopSessionRecording()
}

let currentUserId = null

export function resetIfNewUser(userId) {
  if (!initialized) return

  const id = String(userId)
  if (currentUserId && currentUserId !== id) {
    posthog.reset()
  }
  currentUserId = id
}
